import React, { useState, useEffect, useContext, useLayoutEffect } from 'react';
import { IoIosClose } from 'react-icons/io';

import * as S from './styles';
import SimpleInput from 'components/SimpleInput';
import useDebounce from 'hooks/useDebounce';
import { searchCollection, getProductBySKU } from './reqs';
import { CollectionProps } from 'types/CollectionProps';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import { color } from 'styles/pallete';
import Load from 'components/Load';
import { DataFormProps } from 'components/FormDynamicPageSelected/Forms/InputsProductGrid';

interface InputSearchByCollectionProps {
	initialValue: string;
	getCollection: any;
	setDataForm: React.Dispatch<React.SetStateAction<DataFormProps>>;
	maxHeightList?: number;
}

export default function InputSearchByCollection({
	initialValue,
	getCollection,
	setDataForm,
	maxHeightList = 150
}: InputSearchByCollectionProps) {
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);
	const [valueToSearch, setValueToSearch] = useState('');
	const [isReq, setIsReq] = useState(false);
	const [canReq, setCanReq] = useState(false);
	const [listCollection, setListCollection] = useState<CollectionProps[]>([]);
	const [productSelected, setProductSelected] =
		useState<CollectionProps | null>(null);

	const queryToSearch = useDebounce(valueToSearch, 1000);

	function selectCollection(item: CollectionProps) {
		setProductSelected(item);
		setValueToSearch(item.name);
		setListCollection([]);
		setCanReq(false);
		getCollection({
			name: item.name,
			reference_id: item.id.toString()
		});
	}

	function unselectItem() {
		setProductSelected(null);
		setListCollection([]);
		setValueToSearch('');
		setCanReq(false);
		setDataForm((obj) => ({ ...obj, products: [] }));
	}

	//caso esteja em edição
	useLayoutEffect(() => {
		setValueToSearch(initialValue);
	}, [initialValue]);

	useEffect(() => {
		(async () => {
			if (
				canReq &&
				!productSelected &&
				typeof queryToSearch === 'string' &&
				queryToSearch !== ''
			) {
				setIsReq(true);
				await searchCollection(queryToSearch, setListCollection, handleNotify);
				setIsReq(false);
			}

			if (queryToSearch === '') {
				setListCollection([]);
			}
		})();
	}, [queryToSearch, productSelected]);

	//apos escolher a coleção, busca os produtos pelo sku
	useEffect(() => {
		(async () => {
			if (productSelected !== null) {
				setMessage('Caregando produtos');
				setIsOpenLoad(true);
				const { isSuccess, products } = await getProductBySKU(
					productSelected.id,
					handleNotify
				);
				setIsOpenLoad(false);

				if (isSuccess && products.length > 0) {
					setDataForm((obj) => ({ ...obj, products: products }));
				}
			}
		})();
	}, [productSelected]);

	return (
		<S.container>
			<SimpleInput
				label="Nome da coleção *"
				initialValue={valueToSearch}
				getValue={(value: string) => {
					setCanReq(true);
					setValueToSearch(value);
				}}
			/>

			{!isReq && productSelected === null && listCollection.length > 0 && (
				<S.containerList $maxHeightList={maxHeightList}>
					{listCollection.map((item) => (
						<S.itemList key={item.id} onClick={() => selectCollection(item)}>
							<p>{item.name}</p>
						</S.itemList>
					))}
				</S.containerList>
			)}

			{!isReq && productSelected !== null && (
				<S.unselect>
					<IoIosClose onClick={() => unselectItem()} />
				</S.unselect>
			)}

			{isReq && (
				<S.centralize>
					<Load
						colorBackgound={color.system.success}
						showText
						text="Buscando coleções"
					/>
				</S.centralize>
			)}
		</S.container>
	);
}
